"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("platform/platform.js");
exports.platform = window['platform'];
